import React, { useState, useEffect } from 'react';
import './index.css';
import {
  FormGroup,
  Container,
  Col,
  Row,
  Form,
  Input,
  Label,
} from 'reactstrap';
import { editDealer } from '../../../constants/apiCalls';
import { useNavigate, useLocation } from 'react-router-dom';
import ModalService from '../../../services/ModalService';
import CustomSpinner from '../../../Components/CustomSpinner/CustomSpinner';
import { DashBoardTitle } from '../../../Components/Title';
import { Breadcrumbs } from '../../../Components/Breadcrumbs/Breadcrumbs';
import Storage from '../../../services/Storage';
import { CommonButton } from '../../../Components/CommonComponents';
import { handleErrorMessage } from '../../../utils/utils';
import { useDispatch, useSelector } from 'react-redux';
import { dealerInfoAction } from '../../../reducers/DealerReducer';
import AppHeader from '../../../Layout/AppHeader';
import AppSidebar from '../../../Layout/AppSidebar';

const CropAcreages = () => {
  const navigate = useNavigate();
  const [isLoading, setIsloading] = useState(false);
  const [isKycRequired, setIsKycRequired] = useState(false);
  const [title, setTitle] = useState({});
  let location = useLocation();

  const initialValues = {
    kharifCropName1: null,
    kharifCropName2: null,
    kharifCropName3: null,
    kharifCropName4: null,
    rabiCropName1: null,
    rabiCropName2: null,
    rabiCropName3: null,
    rabiCropName4: null,
    kharifAcreagesName1: null,
    kharifAcreagesName2: null,
    kharifAcreagesName3: null,
    kharifAcreagesName4: null,
    rabiAcreagesName1: null,
    rabiAcreagesName2: null,
    rabiAcreagesName3: null,
    rabiAcreagesName4: null,
  };
  const [formValues, setFormValues] = useState(initialValues);
  let stringArr = location.pathname.split(/(\d+)/);
  let userId = stringArr[1];

  const dispatch = useDispatch();
  const { dealerObj } = useSelector(state => state.DealerReducer);

  useEffect(() => {
    if (userId) {
      setIsloading(true);
      dispatch(dealerInfoAction(parseInt(userId), setIsloading));
    }
  }, []);

  useEffect(() => {
    setIsKycRequired(dealerObj.is_approved);
    setFormValues({
      kharifCropName1: dealerObj.kharif_crop_name_1,
      kharifCropName2: dealerObj.kharif_crop_name_2,
      kharifCropName3: dealerObj.kharif_crop_name_3,
      kharifCropName4: dealerObj.kharif_crop_name_4,
      kharifAcreagesName1: dealerObj.kharif_crop_acreages_1,
      kharifAcreagesName2: dealerObj.kharif_crop_acreages_2,
      kharifAcreagesName3: dealerObj.kharif_crop_acreages_3,
      kharifAcreagesName4: dealerObj.kharif_crop_acreages_4,
      rabiCropName1: dealerObj.rabi_crop_name_1,
      rabiCropName2: dealerObj.rabi_crop_name_2,
      rabiCropName3: dealerObj.rabi_crop_name_3,
      rabiCropName4: dealerObj.rabi_crop_name_4,
      rabiAcreagesName1: dealerObj.rabi_crop_acreages_1,
      rabiAcreagesName2: dealerObj.rabi_crop_acreages_2,
      rabiAcreagesName3: dealerObj.rabi_crop_acreages_3,
      rabiAcreagesName4: dealerObj.rabi_crop_acreages_4,

    });
    setTitle({ name: dealerObj.business_name, page: dealerObj.page_2 });
  }, [dealerObj])

  const handleChange = (e, key) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
  };

  const handleSaveAsDraft = (evt) => {
    evt.preventDefault();
    let payload = {
      id: userId,
      kharif_crop_name_1: formValues.kharifCropName1,
      kharif_crop_acreages_1: formValues.kharifAcreagesName1,
      kharif_crop_name_2: formValues.kharifCropName2,
      kharif_crop_acreages_2: formValues.kharifAcreagesName2,
      kharif_crop_name_3: formValues.kharifCropName3,
      kharif_crop_acreages_3: formValues.kharifAcreagesName3,
      kharif_crop_name_4: formValues.kharifCropName4,
      kharif_crop_acreages_4: formValues.kharifAcreagesName4,
      rabi_crop_name_1: formValues.rabiCropName1,
      rabi_crop_acreages_1: formValues.rabiAcreagesName1,
      rabi_crop_name_2: formValues.rabiCropName2,
      rabi_crop_acreages_2: formValues.rabiAcreagesName2,
      rabi_crop_name_3: formValues.rabiCropName3,
      rabi_crop_acreages_3: formValues.rabiAcreagesName3,
      rabi_crop_name_4: formValues.rabiCropName4,
      rabi_crop_acreages_4: formValues.rabiAcreagesName4,
      page_2: 0,
    };

    if (payload) {
      setIsloading(true);
      editDealer((res) => {
        const { success, message, error } = res;
        if (success === true) {
          ModalService.openAlert('', message, 'success');
          setIsloading(false);
          setTimeout(() => {
            const lastRoute = Storage.backBreadcrumbsButton();
            navigate(lastRoute.url, { replace: true });
          }, 3000);
        } else if (success === false || success === 'undefined') {
          ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
          setIsloading(false);
        }
        setIsloading(false);
      }, payload);
    }
  };

  const handleSubmit = (evt) => {
    evt.preventDefault();
    let payload = {
      id: userId,
      kharif_crop_name_1: formValues.kharifCropName1,
      kharif_crop_acreages_1: formValues.kharifAcreagesName1,
      kharif_crop_name_2: formValues.kharifCropName2,
      kharif_crop_acreages_2: formValues.kharifAcreagesName2,
      kharif_crop_name_3: formValues.kharifCropName3,
      kharif_crop_acreages_3: formValues.kharifAcreagesName3,
      kharif_crop_name_4: formValues.kharifCropName4,
      kharif_crop_acreages_4: formValues.kharifAcreagesName4,
      rabi_crop_name_1: formValues.rabiCropName1,
      rabi_crop_acreages_1: formValues.rabiAcreagesName1,
      rabi_crop_name_2: formValues.rabiCropName2,
      rabi_crop_acreages_2: formValues.rabiAcreagesName2,
      rabi_crop_name_3: formValues.rabiCropName3,
      rabi_crop_acreages_3: formValues.rabiAcreagesName3,
      rabi_crop_name_4: formValues.rabiCropName4,
      rabi_crop_acreages_4: formValues.rabiAcreagesName4,
      page_2: 1,
    };

    if (payload.id) {
      setIsloading(true);
      editDealer((res) => {
        const { success, message, error } = res;
        if (success === true) {
          ModalService.openAlert('', message, 'success');
          setIsloading(false);
          setTimeout(() => {
            const lastRoute = Storage.backBreadcrumbsButton();
            navigate(lastRoute.url, { replace: true });
          }, 3000);
        } else if (success === false || success === 'undefined') {
          ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
          setIsloading(false);
        }
        setIsloading(false);
      }, payload);
    }
  };

  const handleBack = () => {
    const lastRoute = Storage.backBreadcrumbsButton();
    navigate(lastRoute.url, { replace: true });
  };

  return (
    <>
      <AppHeader />
      <div className='app-main'>
        <AppSidebar />
        <div className='app-main__outer'>
          <div className='app-main__inner rms-wrapper'>
            <div id='CropAcreages'>
              {isLoading && <CustomSpinner />}
              <div className='pageWrapper'>
                <Container fluid>
                  <Row>
                    <Col xs={12}>
                      <div className='pageheader'>
                        <DashBoardTitle
                          dashBorardName={
                            title.page === 1 ? title.name : 'New Dealer Registration'
                          }
                        />
                      </div>
                    </Col>
                    <Col xs={12}>
                      <Breadcrumbs title='Coverage Area Details' />
                    </Col>
                  </Row>
                  <div className='cropBlock'>
                    <div className='cropBlockInner'>
                      <Row>
                        <Col xs={12}>
                          <div className='dealerRegBlocktitle text-center noprint'>
                            Coverage Area Details
                          </div>
                          <span className='text-center mandatory-note noprint'>
                            (Please note: all four crops detail are mandatory for both
                            Kharif and Rabi seasons)
                          </span>
                        </Col>
                      </Row>
                      <Form onSubmit={handleSubmit}>
                        <div className='innerArea'>
                          <Row>
                            <Col xs={12}>
                              <div className='cropHeading'>
                                <div className='dealerRegBlocktitleInner mb-0'>Kharif Crops</div>
                                <div className='dealerRegBlocktitleInner note pt-0'>(Note: In Acres)</div>
                              </div>
                            </Col>
                            <Col md={3} className='common-group'>
                              <Label className='common-input-label'>
                                Crop 1 Name<span className='required'>*</span>
                              </Label>
                              <Input
                                className='common-input'
                                type='text'
                                required
                                autoComplete='off'
                                value={
                                  formValues.kharifCropName1 === null ||
                                    formValues.kharifCropName1 === 'undefined'
                                    ? ''
                                    : formValues.kharifCropName1
                                }
                                onChange={(e) => handleChange(e, 1)}
                                placeholder='Type Here'
                                name='kharifCropName1'
                              />
                            </Col>
                            <Col md={3} className='common-group'>
                              <Label className='common-input-label'>
                                Crop 2 Name<span className='required'>*</span>
                              </Label>
                              <Input
                                className='common-input'
                                onChange={(e) => handleChange(e, 2)}
                                type='text'
                                required
                                autoComplete='off'
                                value={
                                  formValues.kharifCropName2 === null ||
                                    formValues.kharifCropName2 === 'undefined'
                                    ? ''
                                    : formValues.kharifCropName2
                                }
                                placeholder='Type Here'
                                name='kharifCropName2'
                              />
                            </Col>
                            <Col md={3} className='common-group'>
                              <FormGroup>
                                <Label className='common-input-label'>
                                  Crop 3 Name<span className='required'>*</span>
                                </Label>
                                <Input
                                  className='common-input'
                                  type='text'
                                  required
                                  autoComplete='off'
                                  value={
                                    formValues.kharifCropName3 === null ||
                                      formValues.kharifCropName3 === 'undefined'
                                      ? ''
                                      : formValues.kharifCropName3
                                  }
                                  onChange={(e) => handleChange(e, 3)}
                                  placeholder='Type Here'
                                  name='kharifCropName3'
                                />
                              </FormGroup>
                            </Col>
                            <Col md={3} className='common-group'>
                              <FormGroup>
                                <Label className='common-input-label'>
                                  Crop 4 Name<span className='required'>*</span>
                                </Label>
                                <Input
                                  className='common-input'
                                  type='text'
                                  required
                                  autoComplete='off'
                                  value={
                                    formValues.kharifCropName4 === null ||
                                      formValues.kharifCropName4 === 'undefined'
                                      ? ''
                                      : formValues.kharifCropName4
                                  }
                                  onChange={(e) => handleChange(e, 3)}
                                  placeholder='Type Here'
                                  name='kharifCropName4'
                                />
                              </FormGroup>
                            </Col>
                            <Col md={3} className='common-group'>
                              <FormGroup>
                                <Label className='common-input-label'>
                                  Crop 1 Acreages<span className='required'>*</span>
                                </Label>
                                <Input
                                  className='common-input'
                                  type='text'
                                  required
                                  onKeyPress={(e) => {
                                    let regex = /^[0-9.\b]+$/;
                                    if (!regex.test(e.key)) {
                                      e.preventDefault();
                                    }
                                    let splitDot =
                                      e.target.value && e.target.value.includes('.')
                                        ? e.target.value.split('.')
                                        : [];
                                    if (splitDot.length > 1 && e.key === '.') {
                                      // only 1 dot
                                      e.preventDefault();
                                    }

                                    if (
                                      splitDot &&
                                      splitDot.length > 1 &&
                                      splitDot[1].length > 2
                                    ) {
                                      e.preventDefault();
                                    }
                                  }}
                                  autoComplete='off'
                                  value={
                                    formValues.kharifAcreagesName1 === null ||
                                      formValues.kharifAcreagesName1 === 'undefined'
                                      ? ''
                                      : formValues.kharifAcreagesName1
                                  }
                                  onChange={(e) => handleChange(e, 3)}
                                  placeholder='Type Here'
                                  name='kharifAcreagesName1'
                                />
                              </FormGroup>
                            </Col>
                            <Col md={3} className='common-group'>
                              <FormGroup>
                                <Label className='common-input-label'>
                                  Crop 2 Acreages<span className='required'>*</span>
                                </Label>
                                <Input
                                  className='common-input'
                                  type='text'
                                  required
                                  autoComplete='off'
                                  onKeyPress={(e) => {
                                    let regex = /^[0-9.\b]+$/;
                                    if (!regex.test(e.key)) {
                                      e.preventDefault();
                                    }
                                    let splitDot =
                                      e.target.value && e.target.value.includes('.')
                                        ? e.target.value.split('.')
                                        : [];
                                    if (splitDot.length > 1 && e.key === '.') {
                                      // only 1 dot
                                      e.preventDefault();
                                    }

                                    if (
                                      splitDot &&
                                      splitDot.length > 1 &&
                                      splitDot[1].length > 2
                                    ) {
                                      e.preventDefault();
                                    }
                                  }}
                                  value={
                                    formValues.kharifAcreagesName2 === null ||
                                      formValues.kharifAcreagesName2 === 'undefined'
                                      ? ''
                                      : formValues.kharifAcreagesName2
                                  }
                                  onChange={(e) => handleChange(e, 3)}
                                  placeholder='Type Here'
                                  name='kharifAcreagesName2'
                                />
                              </FormGroup>
                            </Col>
                            <Col md={3} className='common-group'>
                              <FormGroup>
                                <Label className='common-input-label'>
                                  Crop 3 Acreages<span className='required'>*</span>
                                </Label>
                                <Input
                                  className='common-input'
                                  type='text'
                                  required
                                  autoComplete='off'
                                  onKeyPress={(e) => {
                                    let regex = /^[0-9.\b]+$/;
                                    if (!regex.test(e.key)) {
                                      e.preventDefault();
                                    }
                                    let splitDot =
                                      e.target.value && e.target.value.includes('.')
                                        ? e.target.value.split('.')
                                        : [];
                                    if (splitDot.length > 1 && e.key === '.') {
                                      // only 1 dot
                                      e.preventDefault();
                                    }

                                    if (
                                      splitDot &&
                                      splitDot.length > 1 &&
                                      splitDot[1].length > 2
                                    ) {
                                      e.preventDefault();
                                    }
                                  }}
                                  value={
                                    formValues.kharifAcreagesName3 === null ||
                                      formValues.kharifAcreagesName3 === 'undefined'
                                      ? ''
                                      : formValues.kharifAcreagesName3
                                  }
                                  onChange={(e) => handleChange(e, 3)}
                                  placeholder='Type Here'
                                  name='kharifAcreagesName3'
                                />
                              </FormGroup>
                            </Col>
                            <Col md={3} className='common-group'>
                              <FormGroup>
                                <Label className='common-input-label'>
                                  Crop 4 Acreages<span className='required'>*</span>
                                </Label>
                                <Input
                                  className='common-input'
                                  type='text'
                                  required
                                  autoComplete='off'
                                  onKeyPress={(e) => {
                                    let regex = /^[0-9.\b]+$/;
                                    if (!regex.test(e.key)) {
                                      e.preventDefault();
                                    }
                                    let splitDot =
                                      e.target.value && e.target.value.includes('.')
                                        ? e.target.value.split('.')
                                        : [];
                                    if (splitDot.length > 1 && e.key === '.') {
                                      // only 1 dot
                                      e.preventDefault();
                                    }

                                    if (
                                      splitDot &&
                                      splitDot.length > 1 &&
                                      splitDot[1].length > 2
                                    ) {
                                      e.preventDefault();
                                    }
                                  }}
                                  value={
                                    formValues.kharifAcreagesName4 === null ||
                                      formValues.kharifAcreagesName4 === 'undefined'
                                      ? ''
                                      : formValues.kharifAcreagesName4
                                  }
                                  onChange={(e) => handleChange(e, 3)}
                                  placeholder='Type Here'
                                  name='kharifAcreagesName4'
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                        </div>
                        <div className='innerArea'>
                          <Row>
                            <Col xs={12}>
                              <div className='cropHeading'>
                                <div className='dealerRegBlocktitleInner mb-0'>Rabi Crops</div>
                                <div className='dealerRegBlocktitleInner note pt-0'>(Note: In Acres)</div>
                              </div>
                            </Col>
                            <Col md={3} className='common-group'>
                              <Label className='common-input-label'>
                                Crop 1 Name<span className='required'>*</span>
                              </Label>
                              <Input
                                className='common-input'
                                type='text'
                                required
                                autoComplete='off'
                                value={
                                  formValues.rabiCropName1 === null ||
                                    formValues.rabiCropName1 === 'undefined'
                                    ? ''
                                    : formValues.rabiCropName1
                                }
                                onChange={(e) => handleChange(e, 1)}
                                placeholder='Type Here'
                                name='rabiCropName1'
                              />
                            </Col>
                            <Col md={3} className='common-group'>
                              <Label className='common-input-label'>
                                Crop 2 Name<span className='required'>*</span>
                              </Label>
                              <Input
                                className='common-input'
                                onChange={(e) => handleChange(e, 2)}
                                type='text'
                                required
                                autoComplete='off'
                                value={
                                  formValues.rabiCropName2 === null ||
                                    formValues.rabiCropName2 === 'undefined'
                                    ? ''
                                    : formValues.rabiCropName2
                                }
                                placeholder='Type Here'
                                name='rabiCropName2'
                              />
                            </Col>
                            <Col md={3} className='common-group'>
                              <FormGroup>
                                <Label className='common-input-label'>
                                  Crop 3 Name<span className='required'>*</span>
                                </Label>
                                <Input
                                  className='common-input'
                                  type='text'
                                  required
                                  autoComplete='off'
                                  value={
                                    formValues.rabiCropName3 === null ||
                                      formValues.rabiCropName3 === 'undefined'
                                      ? ''
                                      : formValues.rabiCropName3
                                  }
                                  onChange={(e) => handleChange(e, 3)}
                                  placeholder='Type Here'
                                  name='rabiCropName3'
                                />
                              </FormGroup>
                            </Col>
                            <Col md={3} className='common-group'>
                              <FormGroup>
                                <Label className='common-input-label'>
                                  Crop 4 Name<span className='required'>*</span>
                                </Label>
                                <Input
                                  className='common-input'
                                  type='text'
                                  required
                                  autoComplete='off'
                                  value={
                                    formValues.rabiCropName4 === null ||
                                      formValues.rabiCropName4 === 'undefined'
                                      ? ''
                                      : formValues.rabiCropName4
                                  }
                                  onChange={(e) => handleChange(e, 3)}
                                  placeholder='Type Here'
                                  name='rabiCropName4'
                                />
                              </FormGroup>
                            </Col>
                            <Col md={3} className='common-group'>
                              <FormGroup>
                                <Label className='common-input-label'>
                                  Crop 1 Acreages<span className='required'>*</span>
                                </Label>
                                <Input
                                  className='common-input'
                                  type='text'
                                  required
                                  onKeyPress={(e) => {
                                    let regex = /^[0-9.\b]+$/;
                                    if (!regex.test(e.key)) {
                                      e.preventDefault();
                                    }
                                    let splitDot =
                                      e.target.value && e.target.value.includes('.')
                                        ? e.target.value.split('.')
                                        : [];
                                    if (splitDot.length > 1 && e.key === '.') {
                                      // only 1 dot
                                      e.preventDefault();
                                    }

                                    if (
                                      splitDot &&
                                      splitDot.length > 1 &&
                                      splitDot[1].length > 2
                                    ) {
                                      e.preventDefault();
                                    }
                                  }}
                                  autoComplete='off'
                                  value={
                                    formValues.rabiAcreagesName1 === null ||
                                      formValues.rabiAcreagesName1 === 'undefined'
                                      ? ''
                                      : formValues.rabiAcreagesName1
                                  }
                                  onChange={(e) => handleChange(e, 3)}
                                  placeholder='Type Here'
                                  name='rabiAcreagesName1'
                                />
                              </FormGroup>
                            </Col>
                            <Col md={3} className='common-group'>
                              <FormGroup>
                                <Label className='common-input-label'>
                                  Crop 2 Acreages<span className='required'>*</span>
                                </Label>
                                <Input
                                  className='common-input'
                                  type='text'
                                  required
                                  onKeyPress={(e) => {
                                    let regex = /^[0-9.\b]+$/;
                                    if (!regex.test(e.key)) {
                                      e.preventDefault();
                                    }
                                    let splitDot =
                                      e.target.value && e.target.value.includes('.')
                                        ? e.target.value.split('.')
                                        : [];
                                    if (splitDot.length > 1 && e.key === '.') {
                                      // only 1 dot
                                      e.preventDefault();
                                    }

                                    if (
                                      splitDot &&
                                      splitDot.length > 1 &&
                                      splitDot[1].length > 2
                                    ) {
                                      e.preventDefault();
                                    }
                                  }}
                                  autoComplete='off'
                                  value={
                                    formValues.rabiAcreagesName2 === null ||
                                      formValues.rabiAcreagesName2 === 'undefined'
                                      ? ''
                                      : formValues.rabiAcreagesName2
                                  }
                                  onChange={(e) => handleChange(e, 3)}
                                  placeholder='Type Here'
                                  name='rabiAcreagesName2'
                                />
                              </FormGroup>
                            </Col>
                            <Col md={3} className='common-group'>
                              <FormGroup>
                                <Label className='common-input-label'>
                                  Crop 3 Acreages<span className='required'>*</span>
                                </Label>
                                <Input
                                  className='common-input'
                                  type='text'
                                  required
                                  onKeyPress={(e) => {
                                    let regex = /^[0-9.\b]+$/;
                                    if (!regex.test(e.key)) {
                                      e.preventDefault();
                                    }
                                    let splitDot =
                                      e.target.value && e.target.value.includes('.')
                                        ? e.target.value.split('.')
                                        : [];
                                    if (splitDot.length > 1 && e.key === '.') {
                                      // only 1 dot
                                      e.preventDefault();
                                    }

                                    if (
                                      splitDot &&
                                      splitDot.length > 1 &&
                                      splitDot[1].length > 2
                                    ) {
                                      e.preventDefault();
                                    }
                                  }}
                                  autoComplete='off'
                                  value={
                                    formValues.rabiAcreagesName3 === null ||
                                      formValues.rabiAcreagesName3 === 'undefined'
                                      ? ''
                                      : formValues.rabiAcreagesName3
                                  }
                                  onChange={(e) => handleChange(e, 3)}
                                  placeholder='Type Here'
                                  name='rabiAcreagesName3'
                                />
                              </FormGroup>
                            </Col>
                            <Col md={3} className='common-group'>
                              <FormGroup>
                                <Label className='common-input-label'>
                                  Crop 4 Acreages<span className='required'>*</span>
                                </Label>
                                <Input
                                  className='common-input'
                                  type='text'
                                  required
                                  onKeyPress={(e) => {
                                    let regex = /^[0-9.\b]+$/;
                                    if (!regex.test(e.key)) {
                                      e.preventDefault();
                                    }
                                    let splitDot =
                                      e.target.value && e.target.value.includes('.')
                                        ? e.target.value.split('.')
                                        : [];
                                    if (splitDot.length > 1 && e.key === '.') {
                                      // only 1 dot
                                      e.preventDefault();
                                    }

                                    if (
                                      splitDot &&
                                      splitDot.length > 1 &&
                                      splitDot[1].length > 2
                                    ) {
                                      e.preventDefault();
                                    }
                                  }}
                                  autoComplete='off'
                                  value={
                                    formValues.rabiAcreagesName4 === null ||
                                      formValues.rabiAcreagesName4 === 'undefined'
                                      ? ''
                                      : formValues.rabiAcreagesName4
                                  }
                                  onChange={(e) => handleChange(e, 3)}
                                  placeholder='Type Here'
                                  name='rabiAcreagesName4'
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                          <Row>
                            <Col xs={12}>
                              <div className='common-buttons d-flex flex-wrap align-items-center justify-content-center'>
                                {isKycRequired ? (
                                  <CommonButton name={'Cancel'} btnClass={'btnSecondary'} type="button" onClick={handleBack} />
                                ) : (
                                  <CommonButton name={'Save as Draft'} btnClass={'btnSecondary'} type="button" onClick={handleSaveAsDraft} />
                                )}
                                <CommonButton name={'Submit'} btnClass={'btnPrimary'} type="submit" />
                              </div>
                            </Col>
                          </Row>
                        </div>
                      </Form>
                    </div>
                  </div>
                </Container>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CropAcreages;
